import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../components/auth/auth.service';
import { MainMenuService } from "./main/services/menuservice.service";
import { AppServiceService } from './main/services/product.service';
@Component({
	selector: 'app',
	template: `
  <ngx-ui-loader></ngx-ui-loader>
  <navbar *ngIf="_MainMenuService.isUserLoggedIn && !_MainMenuService.isMRUser"></navbar>
  <mr-header *ngIf="_MainMenuService.isUserLoggedIn && _MainMenuService.isMRUser"></mr-header>
  <router-outlet></router-outlet>
  <appfooter *ngIf="_MainMenuService.isUserLoggedIn && !_MainMenuService.isMRUser"></appfooter>
  <mr-footer *ngIf="_MainMenuService.isUserLoggedIn && _MainMenuService.isMRUser"></mr-footer> 
  `
})

export class AppComponent {
	static parameters = [MainMenuService, AppServiceService, AuthService, Router];

	constructor(private _MainMenuService: MainMenuService, private _AppServiceService: AppServiceService, private _AuthService_: AuthService, private router: Router) {
		let Permission = [];
		this.router = router;
		// this._AuthService_.isLoggedIn().then(is => {
		// 	if (is) {
		// 		try {
		// 			Permission = JSON.parse(localStorage.getItem('permission'));
		// 			this._AppServiceService.OnDashboardDataLoad();
		// 			this._MainMenuService.MenuListSetter(Permission[0]._id);
		// 			this._MainMenuService.UserPermissionSetter();
		// 			this._AuthService_.GetSystemConfigDetails({ "Unit_ID": Permission[0].Unit_ID });
		// 			this._AppServiceService.GetUnitFyearData(Permission[0]._id);
		// 		} catch(ex) {
		// 			localStorage.clear();
		// 			this.router.navigateByUrl('/login');
		// 		}
		// 	} else {
		// 		localStorage.clear();
		// 		this.router.navigateByUrl('/login');
		// 	}
		// })
		try {
			if (this._MainMenuService.isMRUser) {
			  this.loadCommonPermissionForMR();
			} else {
			  this.loadCommonPermissionForUser();
			}
		  } catch (ex) {
			localStorage.clear();
			this.router.navigateByUrl('/login');
		  }
	}

	loadCommonPermissionForUser() {
		this._AuthService_.isLoggedIn().then((is: any) => {
		  if (is) {
			try {
			  const Permission = JSON.parse(localStorage.getItem('permission') as any);
			  this._AppServiceService.OnDashboardDataLoad();
			  this._MainMenuService.MenuListSetter(Permission[0]._id);
			  this._MainMenuService.UserPermissionSetter();
			  this._AuthService_.GetSystemConfigDetails({
				Unit_ID: Permission[0].Unit_ID,
			  });
			  this._AppServiceService.GetUnitFyearData(Permission[0]._id);
			} catch (ex) {
			  localStorage.clear();
			  this.router.navigateByUrl('/login');
			}
		  } else {
			localStorage.clear();
			this.router.navigateByUrl('/login');
		  }
		});
	  }
	
	  loadCommonPermissionForMR() {
	
	  }
}

